import { StoreSearchOutlineIcon } from './StoreSearchOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 1FD8091B-5C35-4157-89E0-7211C77B1E19
 * name store-search-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-search-outline.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const StoreFindOutlineIcon = StoreSearchOutlineIcon;
export default StoreFindOutlineIcon